import { render, staticRenderFns } from "./winning-record.vue?vue&type=template&id=6345fd04&scoped=true"
import script from "./winning-record.vue?vue&type=script&lang=js"
export * from "./winning-record.vue?vue&type=script&lang=js"
import style0 from "./winning-record.vue?vue&type=style&index=0&id=6345fd04&prod&scoped=true&lang=scss"
import style1 from "./winning-record.vue?vue&type=style&index=1&id=6345fd04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6345fd04",
  null
  
)

export default component.exports